module.exports = __webpack_public_path__ + "img/Group 10276.59e4b24c.svg";